import SearchKeyword from './SearchKeyword';

export default SearchKeyword;
